import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/tk_welcome_new_v2_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)
const initialState: {
  homepage?: {
    user_type?: number
    on_mic?: boolean
  }
} = {
  homepage: {},
}

export const NewHouseLuckyStarTr2026Slice = createSlice({
  name: 'NewHouseLuckyStarTr2026',
  initialState,
  reducers: {
    setIsShowPopup: (state, action) => {
      Object.assign(state, {
        isShowPopup: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      Object.assign(state?.homepage, action.payload)
    })
  },
})

export default NewHouseLuckyStarTr2026Slice.reducer
export const NewHouseLuckyStarTr2026Actions =
  NewHouseLuckyStarTr2026Slice.actions
